export const printOutCompany = () => {
  console.log(`
    ============================================
    ============================================
    ============================================
    ============================================
    =================++**##**+==================
    ================#%#++==++#%#================
    ===============%%+========+%#================
    ==============*%+==========+%*==============
    ==============#%============%#==============
    ==============#%============%#==============
    ==============#%============%#==============
    ==============#%============%#==============
    ==============#%============%#==============
    ==============*%+==========+%*==============
    ==============+%#==========#%+==============
    ===============*%#+======+#%*===============
    =================*%##**##%*=================
    ===================++++++===================
    ==================++++++++==================
    ==================########==================
    ============================================
    ============================================
    ============================================
    ============================================
    made with \u{1F9E1} by Quamm srl
  `)
}
